import React from "react";

const Loader = ({
  height = "100vh",
  isLoading = false,
}: {
  height?: string;
  isLoading: boolean;
}) => {
  if (!isLoading) return <></>;

  const styles = `
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes scale-breath {
      0%, 100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(0, 0, 0, 0.3)",
          backdropFilter: "blur(4px)",
          height,
          flexDirection: "column",
          zIndex: 9999,
          overflow: "hidden",
        }}
      >
        {/* Contenedor minimalista */}
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "250px",
            height: "250px",
          }}
        >
          {/* Spinner circular simple */}
          <div
            style={{
              position: "absolute",
              width: "220px",
              height: "220px",
              borderRadius: "50%",
              border: "3px solid transparent",
              borderTopColor: "#dc2626",
              borderRightColor: "#f97316",
              animation: "spin 1.2s linear infinite",
            }}
          />

          {/* Círculo de fondo minimalista */}
          <div
            style={{
              position: "absolute",
              width: "180px",
              height: "180px",
              borderRadius: "50%",
              background: "rgba(255, 255, 255, 0.03)",
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              animation: "scale-breath 3s ease-in-out infinite",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Logo */}
            <img
              alt="Logo Chili"
              width={150}
              src="../../../assets/img/logo/logo_chili_rojo.png"
              style={{
                animation: "scale-breath 2.5s ease-in-out infinite",
                filter: "drop-shadow(0 4px 12px rgba(220, 38, 38, 0.25))",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Loader;
